<template>
  <v-app>
    <navigation></navigation>
    <v-content>
      <loading/>
      <notification/>
      <transition name="fade">
        <router-view v-show="!isLoading"/>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Loading from './ui/basic-components/Loading.vue';
import Navigation from './ui/components/Navigation.vue';
import Notification from './ui/components/Notification/Notification.vue';

export default {
  name: 'app',

  components: {
    Loading,
    Navigation,
    Notification,
  },

  watch: {
    $route(to, from) {
      if (!this.$store.app.state.routeQuerySent) {
        this.$store.app.dispatch('SET_APP_PARAMS', {
          _platform_key: this.$route.query.auth_token,
          zis_locale: this.$route.query.locale,
          last_url: this.$route.query.back_url,
        });
        this.$store.app.state.routeQuerySent = true;
        // this.$router.replace('/');
      }
    },
  },

  computed: {
    isLoading() {
      return this.$store.app.state.isLoading;
    },
  },
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
